import React from 'react'
import './custom-gauge.css'
import Gauge from './Gauge'

const CustomGauge = props => {
    return (
        <div className='custom-gauge-container'>
            <span className='custom-gauge-title'>{props.data.label}</span>
            <Gauge data={props.data}/>
        </div>
    )
}

export default CustomGauge